import React, { useEffect } from "react";
import { Button, Flex, Form, Input, Modal, Select } from "antd";
import { useFetch } from "../../Services/useFetch";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const FolderCreateUpdate = (props) => {
  const { open, setOpen, loadings, fetchBriefFolderList, handleLoading, parentId, folderSlug, userInfo, socket } =
    props;

  const [folderForm] = Form.useForm();
  const { request } = useFetch();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);
  const navigate = useNavigate();

  const handleTrimStart = (name, e) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9\s._\-@(){}\[\],&+=]/g, "");
    folderForm.setFieldsValue({ [name]: sanitizedValue.trimStart() });
    const inputElement = e.target;
    const caretPosition = inputElement.selectionStart - (inputValue.length - sanitizedValue.length);
    inputElement.setSelectionRange(caretPosition, caretPosition);
  };

  const creatBriefFolder = async (values, parentId) => {
    handleLoading("loadingFolder", true);
    const formData = new URLSearchParams();
    formData.append("folder_name", values?.folder_name);
    formData.append("parent_id", parentId);
    try {
      const response = await request("/folder-add", "post", formData, {
        "Content-Type": "application/x-www-form-urlencoded",
      });
      if (response?.data?.status === "1") {
        fetchBriefFolderList(parentId);
        setOpen(false);
        folderForm.resetFields();
        handleLoading("loadingFolder", false);
        notifySuccess("Folder Added Successfully");
        socket.emit("directory-action", {
          userName: userInfo?.userfullname,
          action: "Folder Create",
        });
      } else {
        notify("Folder Already Exist");
        handleLoading("loadingFolder", false);
      }
    } catch (error) {
      console.log("error", error);
      handleLoading("loadingFolder", false);
    }
  };

  const handleOpenCreateEditor = (value) => {
    const typeVal = value == 1 ? "docx" : value == 2 ? "xlsx" : "pptx";
    const url = `/editor?fileType=${encodeURIComponent(typeVal)}&fldId=${encodeURIComponent(parentId)}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    socket.on("directory-action", ({ userName, action }) => {
      // notifySuccess(`${userName} has ${action} a directory.`);
    });

    return () => {
      socket.off("directory-action");
    };
  }, []);

  return (
    <>
      <Modal
        title="Create Folder"
        open={open}
        className="bd_model_main shareModal"
        onCancel={() => {
          folderForm.resetFields();
          setOpen(false);
        }}
        footer={null}
      >
        <Form
          name="validateOnly"
          form={folderForm}
          layout="vertical"
          autoComplete="off"
          onFinish={(val) => creatBriefFolder(val, folderSlug == "outer" ? 0 : parentId)}
        >
          <div className="bd_model_input">
            <Form.Item
              label="Folder Name"
              name="folder_name"
              rules={[{ required: true, message: "Folder name is required" }]}
            >
              <Input placeholder="Enter here" onChange={(e) => handleTrimStart("folder_name", e)} />
            </Form.Item>
          </div>

          <Flex justify="flex-end" align="center">
            <Button key="reset" className="BG_ghostButton" onClick={() => folderForm.resetFields()}>
              Reset
            </Button>
            <Button
              key="submit"
              className="BG_mainButton"
              style={{ marginLeft: "20px" }}
              type="primary"
              htmlType="submit"
              loading={loadings?.loadingFolder}
              disabled={loadings?.loadingFolder}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  );
};

export default FolderCreateUpdate;
